import { useEffect, useState } from 'react'
import { subscribeSystemTheme } from '../lib/lrUiPreferences'

function readDarkClass(): boolean {
  if (typeof document === 'undefined') return false
  return document.documentElement.classList.contains('dark')
}

/** Reagiert auf `html.dark` und System-Theme-Wechsel (bei Präferenz „system“). */
export function useResolvedDarkMode(): boolean {
  const [isDark, setIsDark] = useState(readDarkClass)

  useEffect(() => {
    const root = document.documentElement
    const update = () => setIsDark(readDarkClass())
    const observer = new MutationObserver(update)
    observer.observe(root, { attributes: true, attributeFilter: ['class'] })
    const unsubSystem = subscribeSystemTheme(update)
    return () => {
      observer.disconnect()
      unsubSystem()
    }
  }, [])

  return isDark
}
